import { useAttendance } from "./hook";
import { attendanceMutations } from "./mutations";
import { attendanceQueries } from "./queries";

export const attendanceService = {
  query: attendanceQueries,
  mutation: attendanceMutations,
  useAttendance
};
